<template>
  <div id="dataroom">
    <article class="title py-4 bg-third text-white">
      <b-container fluid>
        <h1 class="text-21 text-lg-32 pl-1 fw-700">
          자료실
        </h1>
      </b-container>
    </article>
    <article class="table-wrapper">
      <table class="table table-dataroom text-14 text-lg-16">
        <thead>
          <tr>
            <th>#</th>
            <th>제목</th>
            <th>작성일</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, i) in allData" :key="i">
            <td>{{ i + 1 }}</td>
            <td @click="$router.push('dataroom/' + data._id)">
              {{ data.title }}
            </td>
            <td>{{ data.createdAt }}</td>
          </tr>
        </tbody>
      </table>
    </article>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      titleTemplate: "마을예술창작소 | " + "자료실",
    };
  },
  data() {
    return {
      allDataRoom: [],
    };
  },
  methods: {
    loadAllDataroom() {
      this.$db
        .collection("allDataRoom")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          if (querySnapshot) {
            this.allDataRoom = arr;
          }
        });
    },
  },
  computed: {
    allData() {
      if (this.allDataRoom) {
        const sort = this.allDataRoom.sort((a, b) => {
          return new Date(b.createdAt) - new Date(a.createdAt);
        });
        return sort;
      }
      return this.allDataRoom;
    },
  },
  mounted() {
    this.loadAllDataroom();
  },
};
</script>

<style lang="scss" scoped>
#dataroom {
  min-height: 100vh;
}
.table-dataroom {
  border-bottom: 2px solid #f99d1b;
  thead {
    th:first-child {
      width: 3%;
    }
    th:nth-child(2) {
      width: 85%;
    }
    th:last-child {
      width: 15%;
    }
    @media all and (max-width: 768px) {
      th:first-child {
        width: 8%;
      }
      th:nth-child(2) {
        width: 62%;
      }
      th:last-child {
        width: 30%;
      }
    }
  }
}
</style>
